<svg class="{$$props.class}" viewBox="0 0 448 512">
  <path
    fill="currentColor"
    d="M400 32H48A48 48 0 000 80v352a48 48 0 0048
    48h137.3V327.7h-63V256h63v-54.6c0-62.2 37-96.5 93.6-96.5 27.2 0 55.5 4.8
    55.5 4.8v61h-31.2c-30.8 0-40.4 19.1-40.4 38.8V256h68.7l-11
    71.7h-57.8V480H400a48 48 0 0048-48V80a48 48 0 00-48-48z" />
</svg>
